import React from 'react';

import { FieldSet, Legend, Spacer } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { KEYS, KEYS_RULES } from '../../../../constants';
import AdditionalRulesTemplate from './AdditionalRulesTemplate';
import RulesCheckbox from './RulesCheckbox';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const CHECKED_STATE = {};

for (const key of Object.keys(KEYS.FIELD_NAME)) {
  CHECKED_STATE[KEYS.FIELD_NAME[key]] = true;
}

const UNCHECKED_STATE = {};

for (const key of Object.keys(KEYS.FIELD_NAME)) {
  UNCHECKED_STATE[KEYS.FIELD_NAME[key]] = false;
}

export default function Keys({ section, setSectionValues }: Props): JSX.Element {
  function toggleKeyRules(): void {
    const isEnabled = section.getFieldValue(KEYS.FIELD_NAME.IS_ENABLED);
    const setCheckboxes = isEnabled ? UNCHECKED_STATE : CHECKED_STATE;

    setSectionValues({
      ...setCheckboxes,
    });
  }

  function onBoxClick(event): void {
    const { value } = event.currentTarget.dataset;
    const checked = section.getFieldValue(value);

    setSectionValues({ [value]: !checked });
  }

  const switchedOn = section.getFieldValue(KEYS.FIELD_NAME.IS_ENABLED);

  return (
    <AdditionalRulesTemplate
      title="Keys"
      caption={`Choose the rules that you would like to govern the property’s keys.`}
      switchTitle="Include key rules"
      switchedOn={switchedOn}
      toggleSwitch={toggleKeyRules}
    >
      {switchedOn && (
        <FieldSet legend={<Legend>Choose which of these optional rules to include with your lease</Legend>}>
          {KEYS_RULES.map((rule, index) => {
            const { FIELD_NAME } = rule;
            const checked = section.getFieldValue(FIELD_NAME);

            return (
              <Spacer marginBottom="xs" key={index}>
                <RulesCheckbox
                  controlId={`RulesCheckbox-${index}`}
                  onBoxClick={onBoxClick}
                  setSectionValues={setSectionValues}
                  {...rule}
                  checked={checked}
                />
              </Spacer>
            );
          })}
        </FieldSet>
      )}
    </AdditionalRulesTemplate>
  );
}
